import { useEffect, useRef, useState } from 'react';
import Styles from './index.module.scss';
import VideoCard from './VideoCard';
import Image from 'next/image';
import { WebPNextImage } from '@/components/WebPImage';
import { VIDEO_SCENE_LIST } from '@/utils/const/products/vod-assessment';
const scrollLeft = '/img/products/vod-assessment/scrollLeft.webp';
const scrollRight = '/img/products/vod-assessment/scrollRight.webp';
export interface IVideoSceneConfig {
  coverUrl: string;
  name: string;
  videoIndex: number;
  description: string;
}

interface IProps {
  videoConfigs: IVideoSceneConfig[];
  onVideoSelect: Function;
}

enum Directions {
  left = 'left',
  right = 'right',
}

const VideoSceneList = ({ videoConfigs, onVideoSelect }: IProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    onVideoSelect(currentIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndex]);

  const [showScrollIcon, setShowScrollIcon] = useState(false);
  const [showRightScrollIcon, setShowRightScrollIcon] = useState(false);
  const [showLeftScrollIcon, setLeftShowScrollIcon] = useState(false);
  // 滚动条
  const VideoListRef = useRef(null);
  const scrollTransform = (direction: Directions) => {
    let left;
    if (direction === Directions.left) {
      left = VideoListRef.current.scrollLeft - 800;
    } else {
      left = VideoListRef.current.scrollLeft + 800;
    }
    VideoListRef.current.scrollTo({
      left,
      behavior: 'smooth',
    });
  };
  const videoSceneListScroll = () => {
    setLeftShowScrollIcon(VideoListRef.current.scrollLeft > 0);
    setShowRightScrollIcon(
      VideoListRef.current.scrollLeft + VideoListRef.current.clientWidth <
        VideoListRef.current.scrollWidth
    );
  };
  const removeVideoSceneListScroll = () => {
    VideoListRef?.current?.removeEventListener('scroll', videoSceneListScroll);
  };
  useEffect(() => {
    videoSceneListScroll();
    VideoListRef.current.addEventListener('scroll', videoSceneListScroll);
    return removeVideoSceneListScroll;
  }, []);

  return (
    <div className={Styles.videoSceneContainer}>
      <div className={Styles.title}>{VIDEO_SCENE_LIST.title}</div>
      <div className={Styles.subTitle}>{VIDEO_SCENE_LIST.subTitle}</div>
      <div className={Styles.videoListContainer}>
        <div
          style={{ position: 'relative' }}
          onMouseEnter={() => setShowScrollIcon(true)}
          onMouseLeave={() => setShowScrollIcon(false)}
        >
          {showScrollIcon && showLeftScrollIcon && (
            <div
              className={`${Styles.scrollOperation} ${Styles.scrollLeft}`}
              onClick={() => scrollTransform(Directions.left)}
            >
              <WebPNextImage
                src={scrollLeft}
                alt="左"
                width={28}
                height={28}
                crossOrigin="anonymous"
              />
            </div>
          )}
          <div className={Styles.videoList} ref={VideoListRef}>
            {videoConfigs.map((item, index) => (
              <VideoCard
                key={item.name}
                name={item.name}
                coverUrl={item.coverUrl}
                selected={index === currentIndex}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
          {showScrollIcon && showRightScrollIcon && (
            <div
              className={`${Styles.scrollOperation} ${Styles.scrollRight}`}
              onClick={() => scrollTransform(Directions.right)}
            >
              <WebPNextImage
                src={scrollRight}
                alt="左"
                width={28}
                height={28}
                crossOrigin="anonymous"
              />
            </div>
          )}
        </div>
      </div>
      <div className={Styles.sceneDesc}>
        {videoConfigs[currentIndex]?.description}
      </div>
    </div>
  );
};

export default VideoSceneList;
